import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./TileContent.html';
import styles from './tile-content-hashed.scss';
import layout from '../../../layouts/LayoutFactory';

export default layout('TileContent', cssUtil.hashTemplate(template, styles), (partial) => {
    partial('Item', cssUtil.hashTemplate('<div class="<%= gwTileContentItem %>" gw-partial-target></div>', styles));
});
